import { render, staticRenderFns } from "./StageIndividual.vue?vue&type=template&id=6cddaf26&scoped=true&"
import script from "./StageIndividual.vue?vue&type=script&lang=js&"
export * from "./StageIndividual.vue?vue&type=script&lang=js&"
import style0 from "./StageIndividual.vue?vue&type=style&index=0&id=6cddaf26&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cddaf26",
  null
  
)

export default component.exports